import {
  routineComputerChoices,
  type RoutineComputerMachine,
} from './desktopTargetSelection';
import { useNativeInstanceId } from './nativeInstanceId';
import { useDesktopTargetRoster } from './useDesktopTargetRoster';

type RoutineComputerList =
  | { status: 'loading' }
  | { status: 'ready'; machines: RoutineComputerMachine[] };

/**
 * Choices for the routine "Preferred computer" dropdown, behind the same flag
 * and roster as the Run by picker. `enabled` gates the whole Computer use section.
 * The roster only loads while the picker is shown, so hidden pickers do not poll.
 */
export function useRoutineComputerChoices(
  pickerVisible: boolean,
  selectorEnabled: () => boolean
): {
  enabled: boolean;
  computers: RoutineComputerList;
  thisComputerId: string | null;
} {
  const enabled = selectorEnabled();
  const loadRoster = enabled && pickerVisible;
  const roster = useDesktopTargetRoster(loadRoster);
  const instance = useNativeInstanceId(loadRoster);

  if (!roster.data) {
    return {
      enabled,
      computers: { status: 'loading' },
      thisComputerId: null,
    };
  }
  const { machines, thisComputerId } = routineComputerChoices(
    roster.data.targets,
    instance.data ?? null
  );
  return {
    enabled,
    computers: { status: 'ready', machines },
    thisComputerId,
  };
}
